module.exports = __webpack_public_path__ + "static/media/javascript_light.b2fcb406.svg";